import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { map } from 'lodash'
import PropTypes from 'prop-types'

const CategoryBreadcrumbs = ({
  namePath,
  idPath,
  rootAppRoute,
  categoryAppRoute,
}) => (
  <Breadcrumb>
    <Breadcrumb.Item>
      <Link to={rootAppRoute.link}>{rootAppRoute.name}</Link>
    </Breadcrumb.Item>
    {map(namePath, (name, index) => (
      <Breadcrumb.Item key={idPath[index]}>
        <Link to={`${categoryAppRoute.link}/${idPath[index]}`}>{name}</Link>
      </Breadcrumb.Item>
    ))}
  </Breadcrumb>
)

CategoryBreadcrumbs.propTypes = {
  idPath: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  namePath: PropTypes.arrayOf(PropTypes.string).isRequired,
  rootAppRoute: PropTypes.shape({
    link: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  categoryAppRoute: PropTypes.shape({
    link: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

export default CategoryBreadcrumbs
